const lastCalls = new Map();

export function notTooOften(key, ms = 1000) {
  const now = Date.now();
  if (lastCalls.has(key) && now - lastCalls.get(key) < ms) return false;
  lastCalls.set(key, now);
  return true;
}
